<section class="placeholder-card placeholder-card--centered" *transloco="let t; prefix: 'parts.modals'">
  <h3>{{ t('compatibleParts.title') }}</h3>
</section>